module.exports = __webpack_public_path__ + "img/P90X2.21ebfcdf.jpeg";